import FormImageUploader from 'components/FormImageUploader/FormImageUploader';
import {
	CreateVideoContext,
	ICreateVideoContext,
} from 'modules/Entertainment/Videos/CreateVideo/createVideoState/createVideoContext';
import React, { useContext } from 'react';
import InputFields from './InputFields/InputFields';
import classNames from 'classnames';
import style from './CreationForm.module.scss';

interface ICreationForm {
	isVisible: boolean;
}

const CreationForm: React.FC<ICreationForm> = ({ isVisible }) => {
	const { setFileId, fileId } = useContext<ICreateVideoContext>(CreateVideoContext);

	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const deletePhotoHandler = () => {
		setFileId(null);
	};

	return (
		<div className={containerClasses} data-test="CreationForm">
			<FormImageUploader
				containerClass={style.imageUploader}
				maxFileSizeMB={1}
				fileId={fileId}
				setFileId={setFileId}
				deletePhotoHandler={deletePhotoHandler}
				maxWidth={1024}
				maxHeight={1024}
				verticalAspectRatio={1}
				horizontalAspectRatio={1}
				withValidation={true}
				noImageIconId="videoDefaultAvatar"
			/>
			<InputFields />
		</div>
	);
};

export default CreationForm;
